// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/search.js';

import { paths } from '../generated/search';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('search', Original, paths);
